import React, { Component } from "react";
import { Redirect, Route, Router, Switch } from "react-router-dom";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import history from "../../utils/history";
import Home from "../home/Home";
import NormalLoginForm from "../logIn/NormalLoginForm";
// import AccountForm from "../accounts/AccountForm";
// import UpdateAccountForm from "../accounts/UpdateAccountForm";
import ProtectedRoute from "./ProtectedRoute";
import ViewInvitationComponent from "../invitations/VIewInvitation";

// import CreateAccountForm from "../accounts/CreateAccountForm";
class Navigator extends Component {
  render() {
    let { is_authenticated, resetSession, state_fetched } = this.props.context;
    let user_type = this.props.context.user.userType;

    if (!state_fetched) {
      return <div />;
    }
    return (
      <Router history={history}>
        <Switch>
          <Route
            exact
            path="/"
            render={() =>
              is_authenticated ? (
                user_type == "SUPER" || user_type == "CARE" ? (
                  <Redirect to="/home/accounts" />
                ) : (
                  <Redirect to="/home/dashboard" />
                )
              ) : (
                <Redirect to="/login" />
              )
            }
          />
          <ProtectedRoute path="/home" access={true} component={Home} />

          <Route
            exact
            path="/login"
            render={() =>
              !is_authenticated ? (
                <NormalLoginForm />
              ) : user_type == "SUPER" || user_type == "CARE" ? (
                <Redirect to="/home/accounts" />
              ) : (
                <Redirect to="/home/dashboard" />
              )
            }
          />

          <Route
            exact
            path="/invite/:token"
            render={() =>
              <ViewInvitationComponent />
            }
          />

          <Route
            exact
            path="/logout"
            render={(props) => {
              let { history } = props;
              resetSession();
              history.push("/login");
              return null;
            }}
          />
        </Switch>
      </Router>
    );
  }
}

export default withSharedStateConsumer(Navigator);
